import apiClient from '../../apiClient';
import '../../App.css'
import { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid'
import { SelectGenericFromTable } from '../universal/Axios';
import { Box, Button } from '@mui/material';
import { HandleAuthError, GenericStackTraceValidator } from '../universal/Alert';
import ArrowForward from '@mui/icons-material/ArrowForward';
import { getStore } from '../../Store'

const SelectionConfigTable = () => {
    const [genAlgSelectionConfigResultsData, setSelectionConfigResultsData] = useState(undefined);

    useEffect(() => {
        SelectGenericFromTable("select * from gen_alg_selection_config;", setSelectionConfigResultsData)
    }, []);


    const genAlgSelectionConfigResultsColumns = [
        {
            field: 'id',
            headerName: 'Selection Config ID',
            width: 440,
            renderCell: (params) => (
                <>
                    {<a
                        href={'create-gen-alg-selection-config?id=' + params.row.id}
                    >
                        {params.row.id}
                    </a>}
                </>
            ),
        },
        {
            field: 'description',
            headerName: 'Description',
            width: 540,
        },
        {
            field: 'created_date',
            headerName: 'Created Date',
            width: 160
        }
    ];

    let genAlgSelectionConfigResultsDataRows = genAlgSelectionConfigResultsData?.filter(data => data != null).map((genAlgSelectionConfigResults) =>
    ({   
        id: genAlgSelectionConfigResults.id,
        description: genAlgSelectionConfigResults.description,
        created_date: genAlgSelectionConfigResults.created_date
    }))


    if (genAlgSelectionConfigResultsData === undefined) {
        return (<p>loading...</p>)
    }
    return (
        <DataGrid
            disableSelectionOnClick
            rows={genAlgSelectionConfigResultsDataRows}
            columns={genAlgSelectionConfigResultsColumns}
            pagination={true}
            initialState={{
              sorting: {
                    sortModel: [{ field: 'created_date', sort: 'desc' }],
              },
            }}
            autoHeight
      />
    )
};

export { SelectionConfigTable };
